module.exports = __webpack_public_path__ + "static/media/ab-educations.d2ab601a.png";